export const SAVED_SEARCH_INIT = 'SAVED_SEARCH_INIT';
export const SAVED_SEARCH_ADD = 'SAVED_SEARCH_ADD';
export const SAVED_SEARCH_REMOVE = 'SAVED_SEARCH_REMOVE';
export const SAVED_SEARCH_SET_DEFAULT = 'SAVED_SEARCH_SET_DEFAULT';
export const SAVED_SEARCH_SELECT = 'SAVED_SEARCH_SELECT';
export const SAVED_SEARCH_CLEAR_SELECTED = 'SAVED_SEARCH_CLEAR_SELECTED';

export const LAST_SEARCH_SET = 'LAST_SEARCH_SET';

export const TEST_DENOMINATION_ADD = 'TEST_DENOMINATION_ADD';
export const TEST_DENOMINATION_REMOVE = 'TEST_DENOMINATION_REMOVE';
export const TEST_DENOMINATION_ADD_MULTIPLE = 'TEST_DENOMINATION_ADD_MULTIPLE';
export const TEST_DENOMINATION_REFRESH = 'TEST_DENOMINATION_REFRESH';
export const TEST_DENOMINATION_REQ_ADVICE = 'TEST_DENOMINATION_REQ_ADVICE';
export const TEST_DENOMINATION_REQ_ADVICE_CANCEL = 'TEST_DENOMINATION_REQ_ADVICE_CANCEL';

export const NOTIFICATION_INIT = 'NOTIFICATION_INIT';
export const NOTIFICATION_MARK_AS_READ = 'NOTIFICATION_MARK_AS_READ';
